import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/constants/routes.json';

export default class ZWallet extends Component {
    render() {
        return (
            <Fragment>
                <h6 className="navbar-heading text-muted">Carteira Digital</h6>
                <ul className="navbar-nav mb-md-3">
                    <li className="nav-item">
                        <Link className="nav-link" to={routes.ZWALLET_DASHBOARD}>
                            <i className="fas fa-wallet text-danger mr-4" />
                            <span>Resumo</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to={routes.ZWALLET_OPERATIONS}>
                            <i className="fas fa-list text-danger mr-4" />
                            <span>Extrato</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to={routes.ZWALLET_PAYMENT}>
                            <i className="fas fa-dollar-sign text-danger mr-4" />
                            <span>Pagamentos</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to={routes.ZWALLET_TRANSFER}>
                            <i className="fas fa-exchange-alt text-danger mr-4" />
                            <span>Transferências</span>
                        </Link>
                    </li>
                </ul>   
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar/ZWallet.js